module.exports = __webpack_public_path__ + "static/media/notice-title.caf32098.svg";